/* eslint-disable no-param-reassign,consistent-return */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import {
  createCurrenciesRoute,
  deleteCurrenciesVersionsRoute,
  getCurrenciesCrossRatesRoute,
  getCurrenciesRoute,
  getCurrenciesVersionsPageableRoute,
  getCurrenciesVersionsRoute,
  postCurrenciesRoute,
} from "../../lib/routes/currencies";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import Message from "../../components/Message/Message";

const initialState = {
  currenciesData: [],
  currenciesDataLoading: rtkRequestStatusCodes.idle,
  currenciesDataVersions: [],
  currenciesDataVersionsLoading: rtkRequestStatusCodes.idle,
  currenciesDataVersionsPageable: [],
  currenciesDataVersionsPageableLoading: rtkRequestStatusCodes.idle,
  currency: [],
  currenciesCreateLoading: rtkRequestStatusCodes.idle,
  currenciesUpdatingLoading: rtkRequestStatusCodes.idle,
  currencyDelete: null,
  currencyDeleteLoading: rtkRequestStatusCodes.idle,
  currenciesCrossRatesData: [],
  currenciesCrossRatesDataLoading: rtkRequestStatusCodes.idle,
};

const fetchCurrencies = createAsyncThunk("currencies/fetchCurrencies", async () => {
  try {
    const url = getCurrenciesRoute();
    const { data } = await axios(url);
    return data.sort((a, b) => a.id - b.id);
  } catch (e) {
    Message("Ошибка загрузки валют. Попробуйте позже", e);
  }
});

const fetchCurrenciesVersions = createAsyncThunk("currencies/fetchCurrenciesVersions", async () => {
  try {
    const url = getCurrenciesVersionsRoute();
    const { data } = await axios(url);
    return data;
  } catch (e) {
    Message("Ошибка загрузки валют. Попробуйте позже", e);
  }
});

const fetchCurrenciesVersionsPageable = createAsyncThunk(
  "currencies/fetchCurrenciesVersionsPageable",
  async ({ id, queryString }) => {
    try {
      const url = [getCurrenciesVersionsPageableRoute(id), queryString].join("");
      const { data } = await axios(url);
      return data;
    } catch (e) {
      Message("Ошибка загрузки валют. Попробуйте позже", e);
    }
  }
);

const createCurrenciesVersions = createAsyncThunk("currencies/create", async ({ values }) => {
  try {
    const response = axios.post(createCurrenciesRoute(), values);
    const { data } = await response;
    const { status } = await response;
    Message("Версия успешно создана", status);
    return data;
  } catch (e) {
    Message("Ошибка создания", e);
  }
});

const updateCurrenciesVersions = createAsyncThunk(
  "currencies/update",
  async ({ flag, onDate, values }) => {
    try {
      const response = axios.patch(postCurrenciesRoute(flag, onDate), values);
      const { data } = await response;
      const { status } = await response;
      if (!flag) Message("Версия успешно создана", status);
      else Message("Версия успешно обновлена", status);

      return data;
    } catch (e) {
      if (!flag) Message("Ошибка создания версии", e);
      else Message("Ошибка обновления версии", e);
    }
  }
);

const deleteCurrenciesVersions = createAsyncThunk("currencies/delete", async ({ id, onDate }) => {
  try {
    const response = axios.delete(deleteCurrenciesVersionsRoute(id, onDate));
    const { data } = await response;
    const { status } = await response;
    Message("Версия успешно обновлена", status);
    return data;
  } catch (e) {
    Message("Ошибка обновления", e);
  }
});

const fetchCurrenciesCrossRates = createAsyncThunk(
  "currencies/fetchCurrenciesCrossRates",
  async (onDate) => {
    try {
      const url = getCurrenciesCrossRatesRoute(onDate);
      const { data } = await axios(url);
      return data;
    } catch (e) {
      Message("Ошибка загрузки кросс валют. Попробуйте позже", e);
    }
  }
);

const slice = createSlice({
  name: "currencies",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchCurrencies.fulfilled]: (state, { payload }) => {
      state.currenciesData = payload;
      state.currenciesDataLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchCurrencies.pending]: (state) => {
      state.currenciesDataLoading = rtkRequestStatusCodes.pending;
    },

    [fetchCurrenciesVersions.fulfilled]: (state, { payload }) => {
      state.currenciesDataVersions = payload;
      state.currenciesDataVersionsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchCurrenciesVersions.pending]: (state) => {
      state.currenciesDataVersionsLoading = rtkRequestStatusCodes.pending;
    },

    [fetchCurrenciesVersionsPageable.fulfilled]: (state, { payload }) => {
      state.currenciesDataVersionsPageable = payload;
      state.currenciesDataVersionsPageableLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchCurrenciesVersionsPageable.pending]: (state) => {
      state.currenciesDataVersionsPageableLoading = rtkRequestStatusCodes.pending;
    },

    [createCurrenciesVersions.pending]: (state) => {
      state.currenciesCreateLoading = rtkRequestStatusCodes.pending;
    },
    [createCurrenciesVersions.fulfilled]: (state, { payload }) => {
      state.currency = payload;
      state.currenciesCreateLoading = rtkRequestStatusCodes.fulfilled;
    },
    [createCurrenciesVersions.rejected]: (state) => {
      state.currenciesCreateLoading = rtkRequestStatusCodes.rejected;
    },

    [updateCurrenciesVersions.pending]: (state) => {
      state.currenciesUpdatingLoading = rtkRequestStatusCodes.pending;
    },
    [updateCurrenciesVersions.fulfilled]: (state, { payload }) => {
      state.currency = payload;
      state.currenciesUpdatingLoading = rtkRequestStatusCodes.fulfilled;
    },
    [updateCurrenciesVersions.rejected]: (state) => {
      state.currenciesUpdatingLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchCurrenciesCrossRates.fulfilled]: (state, { payload }) => {
      state.currenciesCrossRatesData = payload;
      state.currenciesCrossRatesDataLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchCurrenciesCrossRates.pending]: (state) => {
      state.currenciesCrossRatesDataLoading = rtkRequestStatusCodes.pending;
    },
  },
});

const { reducer } = slice;

export {
  fetchCurrencies,
  fetchCurrenciesVersions,
  createCurrenciesVersions,
  updateCurrenciesVersions,
  fetchCurrenciesVersionsPageable,
  deleteCurrenciesVersions,
  fetchCurrenciesCrossRates,
};

export default reducer;
